var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 191,
    viewBox: "0 0 174 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 137.075L95.1027 190.826L173.193 145.751L80.0904 92L2 137.075Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.975 132.052L96.2662 172.88L16.6419 126.799L87.3508 85.98L166.975 132.052Z",
    fill: "#7FB95F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.975 132.052L96.2662 172.88L16.6419 126.799L87.3508 85.98L166.975 132.052Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3508 30.6379V85.98L16.6419 126.799V71.4662L87.3508 30.6379Z",
    fill: "#7FB95F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M87.3508 30.6379V85.98L16.6419 126.799V71.4662L87.3508 30.6379Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2662 117.538V172.88L16.6419 126.799V71.4663L96.2662 117.538Z",
    fill: "#7FB95F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M96.2662 117.538V172.88L16.6419 126.799V71.4663L96.2662 117.538Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.975 76.7099V132.052L87.3508 85.98V30.6379L166.975 76.7099Z",
    fill: "#7FB95F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M166.975 76.7099V132.052L87.3508 85.98V30.6379L166.975 76.7099Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.975 132.052V76.71L96.2662 117.538V172.88L166.975 132.052Z",
    fill: "#7FB95F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M166.975 132.052V76.71L96.2662 117.538V172.88L166.975 132.052Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3508 30.638L87.4467 0L166.879 46.1295L166.975 76.71L87.3508 30.638Z",
    fill: "#7FB95F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.3508 30.638L87.4467 0L166.879 46.1295L166.975 76.71L87.3508 30.638Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2662 117.538L102.9 90.7349L172.967 50.2805L166.975 76.7101L96.2662 117.538Z",
    fill: "#7FB95F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.2662 117.538L102.9 90.7349L172.967 50.2805L166.975 76.7101L96.2662 117.538Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6419 71.4663L8.20592 43.6658L78.9148 2.84717L87.3508 30.638L16.6419 71.4663Z",
    fill: "#7FB95F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.6419 71.4663L8.20592 43.6658L78.9148 2.84717L87.3508 30.638L16.6419 71.4663Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6419 71.4663L0 48.4878L79.6338 94.5598L96.2662 117.538L16.6419 71.4663Z",
    fill: "#7FB95F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M16.6419 71.4663L0 48.4878L79.6338 94.5598L96.2662 117.538L16.6419 71.4663Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0 48.4878L79.6338 94.5598L96.2662 117.538L78.7519 95.3746L0 48.4878Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M166.975 76.71L96.2662 117.538V172.88L97.5891 118.65L166.975 76.71Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.cf6a764ad7b05bca4bf6b7064fc19c67.svg";
export { ForwardRef as ReactComponent };